/*
 * @Author: lijian
 * @Date: 2022-06-06 09:44:40
 * @LastEditors: lijian
 * @LastEditTime: 2022-11-30 12:04:36
 * @Description:
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import VueParticles from "vue-particles";
import VueClipboard from "vue-clipboard2";

import "./assets/css/init.css";
import "./assets/css/ele.css";
import "./assets/css/common.css";

import "./pages/index/components";

import hljs from "highlight.js";
import "highlight.js/styles/default.css";

import http from "./http/http";
import api from "./http/api";
import hint from "./assets/js/hint.js";
import getEmtion from "./assets/js/getEmtion.js";
import crypto from "./assets/js/crypto.js";

import Directive from "./directive";
// 使用插件
Vue.use(Directive);
Vue.use(VueParticles);
Vue.use(VueClipboard);
Vue.use(hljs.vuePlugin);

Vue.prototype.$http = http;
Vue.prototype.$api = api;
Vue.prototype.$hint = hint;
Vue.prototype.$getEmtion = getEmtion;
Vue.prototype.$crypto = crypto;

Vue.config.productionTip = false;

Vue.use(ElementUI);

router.beforeEach((to, from, next) => {
  // 路由白名单
  let routerWhitelist = [
    "/login",
    "/dayReport",
    "/home",
    "/download",
    "/imgIdentify",
    "/videoIdentify",
    "/docList",
    "/realTime",
    "/frontProJect",
    "/Hbase",
    "/privacyPolicy"
  ];
  var token = localStorage.getItem("token");
  if (!token) {
    if (routerWhitelist.includes(to.path)) {
      next();
    } else {
      // next('/login')
      next("/home");
    }
  } else {
    next();
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  store,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js